export const pointRetraitSelectorProps = () => ({
  services: {
    type: Array,
    required: false,
    default() {
      return [];
    }
  },
  infosPossibleServices: {
    type: [Object, Array],
    required: true
  }
})

export const pointRetraitSelectorEmits = () => ([
  "serviceSelected"
])

export const usePointRetraitSelector = (props, context) => {

  const positions = computed(() => {
    return props.services.filter(service => service.gps && service.gps.latitude && service.gps.longitude).map((service) => {
      return {
        id: service.id,
        lat: service.gps ? parseFloat(service.gps.latitude) : 0,
        lng: service.gps ? parseFloat(service.gps.longitude) : 0,
        title: service.description,
        type: service.type,
        sousType: service.sous_type,
        description: service.adresse + (service.description.details ? `(${service.description.details})` : ''),
        disabled: props.infosPossibleServices[service.id] ? (props.infosPossibleServices[service.id].possible === false) : true,
        disabledText: props.infosPossibleServices[service.id] ? props.infosPossibleServices[service.id].raison : ""
      }
    });
  })
  const showMap = computed(() => {
    return props.services.length === positions.value.length;
  })

  const serviceSelected = (service) => {
    context.emit('serviceSelected', service);
  }
  const serviceSelectedFromMap = (position) => {
    const service = getServiceFromPosition(position);
    if (service) {
      serviceSelected(service);
    }
  }
  const getServiceFromPosition = (position) => {
    return props.services.find((service) => {
      return service.id === position.id;
    });
  }
  const getServicePosition = (service) => {
    return {
      lat: service.gps ? parseFloat(service.gps.latitude) : 0,
      lng: service.gps ? parseFloat(service.gps.longitude) : 0
    };
  }
  return {
    positions,
    showMap,
    serviceSelected,
    serviceSelectedFromMap,
    getServiceFromPosition,
    getServicePosition
  }
}